import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    id: String,
    options: Object,
    detailsType: String,
    detailsId: String,
  };

  Chart = () => {
    try {
      const container = document.getElementById(this.idValue);
      if (!container) {
        console.error(`Chart container with id '${this.idValue}' not found`);
        return;
      }

      // Ensure container has proper dimensions
      if (container.offsetHeight === 0) {
        container.style.minHeight = '16rem';
      }

      this.chart = window.echarts.init(container, null, {
        renderer: 'svg',
        useDirtyRect: true,
      });

      this.chart.setOption(this.optionsValue);

      // Remove loading state
      container.classList.remove('loading');

      // Handle chart resize with debouncing
      let resizeTimeout;
      const handleResize = () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          if (this.chart && !this.chart.isDisposed()) {
            this.chart.resize();
          }
        }, 100);
      };

      // Add resize listeners
      window.addEventListener('resize', handleResize);

      // Store cleanup function
      this.cleanup = () => {
        window.removeEventListener('resize', handleResize);
        clearTimeout(resizeTimeout);
      };

      if (this.detailsIdValue !== '') {
        this.chart.on(
          'click',
          this.detailsTypeValue === '' ? 'series' : this.detailsTypeValue,
          this.openChartDetails.bind(this)
        );
      }
    } catch (error) {
      console.error('Error initializing chart:', error);
      // Keep loading state if there's an error
    }
  };

  openChartDetails(params) {
    this.element.dispatchEvent(
      new CustomEvent('openChartDetails', {
        detail: { ...params, chartType: this.detailsIdValue },
        bubbles: true,
      })
    );
  }

  initChart = () => {
    if (window.echarts && window.echartsLoaded) {
      this.Chart();
    } else if (window.echartsLoaded) {
      setTimeout(() => this.initChart(), 100);
    } else {
      window.addEventListener('echarts:loaded', () => setTimeout(() => this.initChart(), 100), { once: true });
    }
  };

  initialize() {
    if (window.echarts && window.echartsLoaded) {
      this.initChart();
    } else {
      this.initChart();
    }
  }

  disconnect() {
    if (this.cleanup) {
      this.cleanup();
    }
    if (this.chart && !this.chart.isDisposed()) {
      this.chart.dispose();
    }
  }
}
